import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { Box, Typography } from '@mui/material';

import theme from 'src/style-system/theme';
import { AppRoutes } from '@utils/appRoutes';
import useAuth from '@utils/useAuth';
import Button from '@components/Button';

import { useStyles } from './useStyles';

interface IReferBanner {
  slice: any;
}

const ReferBanner = ({ slice }: IReferBanner) => {
  const { variation } = slice || {};

  const router = useRouter();
  const { detectedCountryCode: countryCode } = useAuth();

  const getClasses = useStyles({ variation });
  const classes = getClasses();

  const SECOND_VARIATION = 'viewOurPlan';
  const THIRD_VARIATION = 'contactUs';

  const ctaDetail = useMemo(() => {
    switch (variation) {
      case 'viewOurPlan': {
        return {
          title: 'Let’s get you something delicious!',
          ctaText: 'Build Your Box',
          ctaUrl: AppRoutes.ORDER_STEP_ONE,
        };
      }
      case 'contactUs': {
        return {
          title: 'Let’s start a conversation! Go ahead and drop us an email.',
          ctaText: 'Contact Us',
          ctaUrl: 'ragoth@thecuminclub.com',
        };
      }
      default: {
        return {
          title: 'Refer a friend to get $50 today!',
          ctaText: 'Get My URL',
          ctaUrl: AppRoutes.REFERRALS,
        };
      }
    }
  }, [variation]);

  return (
    <Box
      className={classes.container}
      sx={{
        position: variation === SECOND_VARIATION ? 'sticky' : 'block',
        bottom: '0px',
      }}
    >
      <Typography
        variant="body1"
        color="whitePepper.main"
        sx={{
          [theme.breakpoints.down('sm')]: {
            display: variation === SECOND_VARIATION ? 'none' : 'block',
            textAlign: variation === THIRD_VARIATION ? 'center' : 'left',
          },
        }}
      >
        {ctaDetail?.title}
      </Typography>

      <Button
        variant="contained"
        color="turmeric"
        borderRadius="24"
        textColor="cinnamon"
        width={variation === SECOND_VARIATION ? '200px' : '155px'}
        onClick={() =>
          variation === THIRD_VARIATION ? {} : router.push(ctaDetail.ctaUrl)
        }
        className={classes.btn}
      >
        {variation === THIRD_VARIATION ? (
          <a href="mailto:ragoth@thecuminclub.com">{ctaDetail.ctaText}</a>
        ) : (
          ctaDetail.ctaText
        )}
      </Button>
    </Box>
  );
};

export default ReferBanner;
